import React from "react";
import Contact from "../component/Contact";

export default function ContactPag() {
  return (
    <div>
      <Contact />
    </div>
  );
}
